<span [class]="classes()" [ngClass]="ngClass" [attr.aria-label]="ariaLabel ?? label">
  <ng-container *ngIf="icon else badgeLabel">
    <span class="material-icons fs-inherit">{{ icon }}</span>
  </ng-container>
  <ng-template #badgeLabel>
    {{ label }}
  </ng-template>
</span>
